import type { DashboardSummary } from "../../shared/types";
import { mockJobs } from "./jobs";

export const mockSummary: DashboardSummary = {
  totalJobs: mockJobs.length,
  healthyJobs: mockJobs.filter((job) => job.status === "SUCCEEDED" || job.status === "SCHEDULED").length,
  runningJobs: mockJobs.filter((job) => job.status === "RUNNING").length,
  failedJobs: mockJobs.filter((job) => job.status === "FAILED").length,
  missingJobs: mockJobs.filter((job) => job.status === "MISSING").length,
  lateJobs: mockJobs.filter((job) => job.status === "LATE").length,
  longRunningJobs: mockJobs.filter((job) => job.status === "LONG_RUNNING").length,
  cancelledJobs: mockJobs.filter((job) => job.status === "CANCELLED").length,
  unknownJobs: mockJobs.filter((job) => job.status === "UNKNOWN").length,
  lastUpdatedAt: "2026-06-02T13:15:00Z"
};
